import React from "react"
import { AmchartSeeker } from "@ui-seeker/core"
import { Skeleton } from "@mui/material"
import { useInfoBlockData } from "Pages/BusinessLogistics/Analytics/Page/@hooks"
import { REQUEST_TYPE } from "Pages/BusinessLogistics/Analytics/Page/@constants"


export default function EuropcarColumnChart() {

	const { res, isLoading } = useInfoBlockData(`${REQUEST_TYPE.BOOKING}-${REQUEST_TYPE.CHART}`, true)

	const { series, results } = res

	if (isLoading) return <Skeleton variant="rectangular" height={400}/>

	return <AmchartSeeker
		title="Daily searches vs Previous Month"
		rootID="SearchAnalyticsBarChart"
		data={results}
		sx={{ height: 300 }}
		series={series?.map(({ dataKey, label, color }) => {
			const key = dataKey === "searches" ? "date" : "previousDate"
			const value = dataKey === "searches" ? "searches" : "previousSearches"
			return {
				type: "column",
				name: label,
				yField: dataKey,
				xField: 'date',
				color: color,
				tooltip: {
					isDateAxis: true,
					tooltipVisibleOnZero: true,
					labelText: `[bold]{${key}.formatDate('dd MMM yyyy')}:[/] {${value}.formatNumber('#,###')}`
				}
			}
		})}
		chartProps={{
			enabledPDF: false,
			dateFormatReceived: 'yyyy-MM-dd',
			xAxis: {
				title: "Dates",
				categoryField: 'date',
				isDateAxis: true,
				dateFormat: 'dd MMM yyyy',
				baseInterval: {
					timeUnit: 'day',
					count: 1
				},
				hiddenTooltip: true
			},
			yAxis: {
				title: 'N° of Searches'
			},
			scrollbarX: { hidden: true },
		}}
	/>
}